
import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import DungeonCanvas from '../components/DungeonCanvas';
import { Dungeon } from '../types';
import { useDungeonSync } from '../hooks/useDungeonSync';

const VTTPlayerView: React.FC = () => {
    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get('s') || 'default-session';
    const [dungeon, setDungeon] = useState<Dungeon | null>(null);

    // Subscreve ao canal do Supabase baseado no SessionID da URL
    useDungeonSync((updatedDungeon) => {
        setDungeon(updatedDungeon);
    }, sessionId);

    if (!dungeon) {
        return (
            <div className="flex h-screen w-full items-center justify-center bg-black text-stone-700 font-cinzel uppercase tracking-[0.3em] animate-pulse text-[10px]">
                Aguardando Conexão do Arquiteto...
            </div>
        );
    }

    return (
        <div className="h-screen w-full overflow-hidden bg-black flex items-center justify-center">
            <DungeonCanvas
                dungeon={dungeon}
                setDungeon={() => { }} // Jogador não altera o estado no VTT
                isMasterMode={false}
                onEditRoom={() => { }}
                onEditSegment={() => { }}
                onToggleRoom={() => { }}
                onToggleSegment={() => { }}
                customEncounters={[]}
            />

            {/* Overlay discreto de status */}
            <div className="absolute bottom-2 right-2 text-[8px] font-sans text-white/10 uppercase tracking-widest pointer-events-none">
                VTT Live Sync: {sessionId}
            </div>
        </div>
    );
};

export default VTTPlayerView;
